import { io, Socket } from 'socket.io-client';
import { getBaseUrl } from './services/baseUrlService';

let _socket: Socket | null = null;

/**
 * Returns the shared socket instance, creating it on first call.
 * Must be called AFTER the user is authenticated (token in localStorage).
 */
export function getSocket(): Socket {
  if (!_socket) {
    const token = localStorage.getItem('token') || '';
    _socket = io(getBaseUrl(), {
      autoConnect: false,
      auth: { token },
      query: { token },
    });
  }
  return _socket;
}

/**
 * Connect the socket. Call this after a successful login.
 */
export function connectSocket(): Socket {
  const s = getSocket();
  if (!s.connected) s.connect();
  return s;
}

/**
 * Disconnect and destroy the socket. Call this on logout.
 */
export function disconnectSocket() {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
}


